import { render, staticRenderFns } from "./PerfilUsuarioComponent.vue?vue&type=template&id=1e755b61&"
import script from "./PerfilUsuarioComponent.vue?vue&type=script&lang=js&"
export * from "./PerfilUsuarioComponent.vue?vue&type=script&lang=js&"
import style0 from "./PerfilUsuarioComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports